import Vue from 'vue';
import Router from 'vue-router';

import Landing from './views/Landing.vue';
import Terms from './views/Terms.vue';
import Privacy from './views/Privacy.vue';
import Cookie from './views/Cookie.vue';
import Children from './views/Children.vue';

import DigitalOceanBackups from './views/DigitalOceanBackups.vue';
import DigitalOceanHourlyBackups from './views/DigitalOceanHourlyBackups.vue';
import DigitalOceanDailyBackups from './views/DigitalOceanDailyBackups.vue';

import NotFound from './views/NotFound.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import Register from './views/Register.vue';
import ConnectWithGithub from './views/ConnectWithGithub.vue';
import Dashboard from './views/Dashboard.vue';
import CloudAccounts from './views/CloudAccounts.vue';
// import Databases from './views/Databases.vue';
import MysqlDatabases from './views/Databases/MysqlDatabases.vue';
import PostgresqlDatabases from './views/Databases/PostgresqlDatabases.vue';
import Files from './views/Files.vue';
import ShowCloudlet from './views/Cloudlets/Show.vue';
import DigitalOceanCallback from './views/Callbacks/DigitalOceanCallback.vue';
import ShowDatabase from './views/Databases/Show.vue';
import ShowFile from './views/Files/Show.vue';

import CreateServer from './views/Servers/Create.vue';

import DetailsSettings from './views/Settings/Details.vue';
import SecuritySettings from './views/Settings/Security.vue';
import TwoFactorAuthSettings from './views/Settings/2fa.vue';
import StoragesSettings from './views/Settings/Storages.vue';
import StorageSettings from './views/Settings/Storage.vue';
import ServersSettings from './views/Settings/Servers.vue';
import ServerSettings from './views/Settings/Server.vue';
import EncryptionKeysSettings from './views/Settings/EncryptionKeys.vue';
import SubscriptionSettings from './views/Settings/Subscription.vue';

import Analytics from './views/Analytics.vue';

import Multiguard from 'vue-router-multiguard';

import * as jwt_decode from 'jwt-decode';

Vue.use(Router)

const loggedInGuard = (to, from, next) => {
    if (localStorage.getItem('authenticationToken') === null) {
        next('/login');
    }
    next();
};

const notLoggedInGuard = (to, from, next) => {

    if (localStorage.getItem('authenticationToken') != null) {
        var decoded = jwt_decode(localStorage.getItem('authenticationToken'));
        // Check if token is not expired
        if (decoded.exp > Math.round(new Date().getTime()/1000)) {
            next('/dashboard/accounts');
            return;
        }
    }
    next();
};

const landingPageGuard = (to, from, next) => {
    window.location.replace('https://weap.io');
    return;
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,

    routes: [
        {
            path: '/',
            name: 'landing',
            component: Landing,
            beforeEnter: Multiguard([landingPageGuard]),
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms,
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy,
        },
        {
            path: '/cookie',
            name: 'cookie',
            component: Cookie,
        },
        {
            path: '/digital-ocean-backups',
            name: 'digitalOceanBackups',
            component: DigitalOceanBackups,
        },
        {
            path: '/digital-ocean-hourly-backups',
            name: 'digitalOceanHourlyBackups',
            component: DigitalOceanHourlyBackups,
        },
        {
            path: '/digital-ocean-daily-backups',
            name: 'digitalOceanDailyBackups',
            component: DigitalOceanDailyBackups,
        },
        {
            path: '/callback/digitalocean',
            name: 'DigitalOceanCallback',
            component: DigitalOceanCallback,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/login/github',
            name: 'loginWithGithub',
            component: ConnectWithGithub,
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            // beforeEnter: Multiguard([notLoggedInGuard]),
        },
        {
            path: '/register/github',
            name: 'registerWithGithub',
            component: ConnectWithGithub,
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
          beforeEnter: Multiguard([loggedInGuard])
        },
        {
          path: '/dashboard/accounts',
          name: 'cloudlets',
          component: CloudAccounts,
          beforeEnter: Multiguard([loggedInGuard])
        },
        {
          path: '/dashboard/databases/mysql',
          name: 'mysqlDatabases',
          component: MysqlDatabases,
          beforeEnter: Multiguard([loggedInGuard])
        },
        {
          path: '/dashboard/databases/postgresql',
          name: 'postgresqlDatabases',
          component: PostgresqlDatabases,
          beforeEnter: Multiguard([loggedInGuard])
        },
        {
          path: '/dashboard/files',
          name: 'files',
          component: Files,
          beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/cloudlets/:id',
            name: 'showCloudlet',
            component: ShowCloudlet,
        },
        {
            path: '/databases/:id',
            name: 'showDatabase',
            component: ShowDatabase,
        },
        {
            path: '/files/:id',
            name: 'showFile',
            component: ShowFile,
        },
        {
            path: '/servers/create',
            name: 'createServer',
            component: CreateServer,
        },
        {
            path: '/settings/details',
            name: 'detailsSettings',
            component: DetailsSettings,
            // beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/security',
            name: 'securitySettings',
            component: SecuritySettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/2fa',
            name: 'twoFactorAuthSettings',
            component: TwoFactorAuthSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/storages',
            name: 'storagesSettings',
            component: StoragesSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/storages/:id',
            name: 'storageSettings',
            component: StorageSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/encryption-keys',
            name: 'encryptionKeysSettings',
            component: EncryptionKeysSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/servers',
            name: 'serversSettings',
            component: ServersSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/servers/:id',
            name: 'serverSettings',
            component: ServerSettings,
            beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '/settings/subscription',
            name: 'subscriptionSettings',
            component: SubscriptionSettings,
            // beforeEnter: Multiguard([loggedInGuard])
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
        },
        // {
          // path: '/about',
          // name: 'about',
          // // route level code-splitting
          // // this generates a separate chunk (about.[hash].js) for this route
          // // which is lazy-loaded when the route is visited.
          // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        // }
    ],

    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
